export const Z_INDEX = {
  TOOLTIP: 10
}
